module.exports = __webpack_public_path__ + "static/media/Type4Icon.becd7eb6.png";